import React, { createContext, useContext, useState, useCallback } from 'react';

interface AppContextType {
  isInitialized: boolean;
  setIsInitialized: (value: boolean) => void;
  initializeApp: () => Promise<void>;
}

const AppContext = createContext<AppContextType | undefined>(undefined);

export const AppProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isInitialized, setIsInitialized] = useState(false);

  const initializeApp = useCallback(async () => {
    if (!isInitialized) {
      setIsInitialized(true);
    }
  }, [isInitialized]);

  return (
    <AppContext.Provider value={{ isInitialized, setIsInitialized, initializeApp }}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useApp must be used within an AppProvider');
  }
  return context;
}; 